<template>
  <div>
    <h3>
      Aplikacja zapisowa napwr.pl
    </h3>
    <div>
      Aby wziąć udział w zapisach musisz znać dedykowany link. Zapytaj o niego organizatorów
      wydarzenia.
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome'
}
</script>

<style scoped></style>
